'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var transparentBg = (0, _color2.default)(_theme2.default.rawColors.grey400).alpha(0).rgb().string();
var opaqueBg = (0, _color2.default)(_theme2.default.rawColors.grey400).alpha(0.8).rgb().string();

var fadeInAnimation = _glamor.css.keyframes('fadeInAnimation', {
  from: {
    backgroundColor: transparentBg
  },
  to: {
    backgroundColor: opaqueBg
  }
});

var fadeOutAnimation = _glamor.css.keyframes('fadeOutAnimation', {
  from: {
    backgroundColor: opaqueBg
  },
  to: {
    backgroundColor: transparentBg
  }
});

var mainCss = (0, _glamor.css)({
  position: 'fixed',
  zIndex: 10,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  background: opaqueBg,
  animationDuration: _theme2.default.animationDuration.slow,
  animationTimingFunction: _theme2.default.animationEasing.standard,
  animationFillMode: 'forwards'
});

var parseProps = function parseProps(_ref) {
  var className = _ref.className,
      fadeOut = _ref.fadeOut,
      onClick = _ref.onClick,
      onFadeEnd = _ref.onFadeEnd,
      props = _objectWithoutProperties(_ref, ['className', 'fadeOut', 'onClick', 'onFadeEnd']);

  return props;
};

var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay() {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleAnimationEnd = _this.handleAnimationEnd.bind(_this);
    return _this;
  }

  _createClass(Overlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.style.overflow = 'hidden';
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.style.overflow = 'initial';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          fadeOut = _props.fadeOut,
          children = _props.children;

      var style = {
        animationName: '' + (fadeOut ? fadeOutAnimation : fadeInAnimation)
      };

      return _react2.default.createElement(
        _Box2.default,
        _extends({}, parseProps(this.props), {
          className: '' + mainCss,
          style: style,
          onRef: function onRef(node) {
            return _this2.node = node;
          },
          onClick: this.handleClick,
          onAnimationEnd: this.handleAnimationEnd
        }),
        children
      );
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      if (this.props.onClick && e.target === this.node) {
        this.props.onClick();
      }
    }
  }, {
    key: 'handleAnimationEnd',
    value: function handleAnimationEnd(e) {
      if (this.props.onFadeEnd && e.target === this.node) {
        this.props.onFadeEnd();
      }
    }
  }]);

  return Overlay;
}(_react.Component);

Overlay.propTypes = _extends({}, _Box2.default.propTypes, {
  fadeOut: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onFadeEnd: _propTypes2.default.func
});

Overlay.defaultProps = {
  fadeOut: false
};

Overlay.displayName = 'Overlay';

exports.default = Overlay;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Overlay.js
// module id = 391
// module chunks = 0